import { Component, OnInit } from '@angular/core';

/**
 * @ignore
 */
@Component({
  selector: 'uex-list-subtitle',
  templateUrl: './subtitle.component.html',
  host: {
    class: 'uex-list-subtitle'
  }
})
export class ListSubtitleComponent implements OnInit {
  constructor() { }

  public ngOnInit() { }
}

/**
 * @ignore
 */
@Component({
  selector: '[uex-list-subtitle]',
  template: '<ng-content></ng-content>',
  host: {
    class: 'uex-list-subtitle'
  }
})
export class ListHeadingSubtitleComponent {
  constructor() { }
}

